import React from 'react'

import ImgSlider from './ImgSlider';

import '../styles/SoftwareCreations.css'
import styled from 'styled-components'

import exe from '../download/TASK-APP.exe';

import { AiFillGithub } from 'react-icons/ai';
import { BsBoxArrowUpRight } from 'react-icons/bs';
import { FaRegFolder } from 'react-icons/fa';

import { BsDownload } from 'react-icons/bs';
import { FiDownload } from 'react-icons/fi'


import Fade from 'react-reveal/Fade';

function SoftwareCreations() {
  return (
    //   <Fade bottom>
          <Container>
            <div id="projects">
                    <Title>Software Creations</Title>

                    {/* <Container2>
                        <ImgSlider />
                    </Container2> */}

                </div>
                <Content>
                <div className='container'>


                {/* <div className='cards'>
                <div className='folder'>
                        <FaRegFolder size={40}/>
                    </div>
                    <SubTitle>Task Tracker</SubTitle>
                    <Des>This application can create and keep track of multiple tasks. Once you have completed a task you can delete it. Login Email: noor.ahmed232003@outlook.com Password: Pass6215@ </Des>
                    <div className='tech'>
                        MongoDB, Express.js, React.JS, Node.js
                    </div>
                    <div className='github'>
                        <a href='https://github.com/N00rAhmed/MERN-Frontend' target="_blank">
                            <AiFillGithub style={{fontsize: 30}} />
                        </a>
                    </div>
                    <div className='icon'>
                        <a href='https://m3rn-task-app.netlify.app' target="_blank">
                            <BsBoxArrowUpRight style={{fontsize: 30}} />
                        </a>
                    </div>
                </div> */}


                <div className='cards'>
                <div className='folder'>
                        <FaRegFolder size={40}/>
                    </div>
                    <SubTitle>Data Migration Tool</SubTitle>
                    <Des>This web app can import excel data into MongoDB. Similarly it can export data by providing the collection name.</Des>
                    <div className='tech'>
                        React.JS, Node.js, Express.js, MongoDB
                    </div>
                    <div className='github'>
                        <a href='https://github.com/N00rAhmed/Import-Export-Tool' target="_blank">
                            <AiFillGithub style={{fontsize: 30}} />
                        </a>
                    </div>
                    <div className='icon'>
                        <a href='https://import-export-tool.netlify.app' target="_blank">
                            <BsBoxArrowUpRight style={{fontsize: 30}} />
                        </a>
                    </div>
                </div>



                <div className='cards'>
                <div className='folder'>
                        <FaRegFolder size={40}/>
                    </div>
                    <SubTitle>Worklist Manager</SubTitle>
                    <Des>This app enables users to login/register, manage tasks etc. To view the project please use my account UserName: noor, Password: pass</Des>

                    <div className='tech'>
                        .NET Framework, Windows Forms, CockroachDB (SQL)
                    </div>
                    <div className='github'>
                        <a href='https://github.com/N00rAhmed/Task-Manager' target="_blank">
                            <AiFillGithub style={{fontsize: 30}} />
                        </a>
                    </div>
                    <div className='icon'>
                        <a href={exe} download>
                            <FiDownload style={{fontsize: 30}} />
                        </a>
                    </div>

                </div>



                <div className='cards'>
                <div className='folder'>
                        <FaRegFolder size={40}/>
                    </div>
                    <SubTitle>Auto Builder</SubTitle>
                    <Des>This is an API builder, a user can get boilerplate code for developing an API. Currently this is an ongoing project.</Des>
                    <div className='tech'>
                        Next.JS, ASP.NET, Scriban, MongoDB {/* Docker */}
                    </div>
                    <div className='github'>
                        <a href='https://github.com/N00rAhmed/Auto-Builder' target="_blank">
                            <AiFillGithub style={{fontsize: 30}} />
                        </a>
                    </div>
                    <div className='icon'>
                        <a href='' target="_blank">
                            {/* <BsBoxArrowUpRight style={{fontsize: 30}} /> */}
                        </a>
                    </div>


                </div>



                <div className='cards'>
                <div className='folder'>
                        <FaRegFolder size={40}/>
                    </div>
                    <SubTitle>Tetris</SubTitle>
                    <Des>This is a cli tetris game made using keyboard characters. Currently this is an ongoing project.</Des>
                    <div className='tech'>
                        C++
                    </div>
                    <div className='github'>
                        <a href='https://github.com/N00rAhmed/Tetris' target="_blank">
                            <AiFillGithub style={{fontsize: 30}} />
                        </a>
                    </div>
                    <div className='icon'>
                        <a href='' target="_blank">
                            {/* <BsBoxArrowUpRight style={{fontsize: 30}} /> */}
                        </a>
                    </div>
                </div>


                <div className='cards'>
                <div className='folder'>
                        <FaRegFolder size={40}/>
                    </div>
                    <SubTitle>Word Combination Generator</SubTitle>
                    <Des>This web app can take user input of letters and generate all possible combinations of words using those letters.</Des>
                    <div className='tech'>
                        Python, Flask, JavaScript, unittest, Docker                        
                    </div>
                    <div className='github'>
                        <a href='https://github.com/N00rAhmed/Word-Combination-Generator' target="_blank">
                            <AiFillGithub style={{fontsize: 30}} />
                        </a>
                    </div>
                    <div className='icon'>
                        <a href='https://word-combination-generator.onrender.com' target="_blank">
                            <BsBoxArrowUpRight style={{fontsize: 30}} />
                        </a>
                    </div>
                </div>


                <div className='cards'>
                <div className='folder'>
                        <FaRegFolder size={40}/>
                    </div>
                    <SubTitle>Pending</SubTitle>
                    <Des>pending.</Des>
                    <div className='tech'>
                        pending
                    </div>
                    <div className='github'>
                        <a href='' target="_blank">
                            <AiFillGithub style={{fontsize: 30}} />
                        </a>
                    </div>
                    <div className='icon'>
                        <a href='' target="_blank">
                            {/* <BsBoxArrowUpRight style={{fontsize: 30}} /> */}
                        </a>
                    </div>
                </div>
                

                {/* <div className='cards'>
                <div className='folder'>
                        <FaRegFolder size={40}/>
                    </div>
                    <SubTitle>Asteroids Game</SubTitle>
                    <Des>The Java Asteroids Game utilizes classes and objects to create components such as the asteroids, spaceship, bullets.</Des>
                    <div className='tech'>
                        Java
                    </div>
                    <div className='github'>
                        <a href='https://github.com/N00rAhmed/Asteroids-Game' target="_blank">
                            <AiFillGithub style={{fontsize: 30}} />
                        </a>
                    </div>
                    <div className='icon'>
                        <a href='' target="_blank">
                            {/* <BsBoxArrowUpRight style={{fontsize: 30}} /> */}
                        {/* </a> */}
                    {/* </div> */}
                {/* </div> */}




            </div>
                </Content>
          </Container>

    //   </Fade>
  )
}

const Container2 = styled.main`
position: relative;
overflow-x: hidden;
overflow-y: hidden;

display: block;

padding: 0 calc(13.5vw + 15px);

`;


const Container = styled.div`
`;

const Content = styled.div`
display: flex;
align-items: right;

padding-right:15%;


`;

const Title = styled.h2`
display: flex;
align-items: left;
font-size: 40px;
padding-top: 40px;

padding-left:15%;

color:rgb(109, 216, 219)
`

const SubTitle = styled.h1`
margin-left: 8px;
padding-top: 3%;
font-size: 25px;
height: 30px;
`

const Des = styled.p`
display: flex;
align-items: center;
height: 100px;
font-family: calibri;
font-size: 17px;
`

export default SoftwareCreations